import * as go from 'gojs';

export const rescaleDiagram = (diagram: go.Diagram, forceZoom = false) => {
  // Start animation transaction for smooth transition
  diagram.startTransaction('rescale');

  const bounds = diagram.documentBounds;
  const { viewportBounds } = diagram;

  if (
    forceZoom ||
    bounds.width > viewportBounds.width ||
    bounds.height > viewportBounds.height
  ) {
    diagram.zoomToFit();
  }

  diagram.alignDocument(go.Spot.Center, go.Spot.Center);

  diagram.commitTransaction('rescale');
};
